import { h, Component } from "preact";
import { TranslateProvider } from "@denysvuika/preact-translate";
import Map from "./mapContainer";

const translations = {
  lv: {
    // "Teritorijas un servisi": "Teritorijas un servisi ",
  },
  en: {
    "Teritorijas un servisi": "Territories and services",
    "Teritorijas": "Territories",
    "Kravām" : "Cargo",
    "Pasažieriem" : "Passengers",
    "Visi objekti" : "Show all",
    'Jahtām' : 'For Yachts',
    'Ostas serviss' : 'Port services',
    'Zaļās zonas' : 'Green zones',
    'Aizsargājamās teritorijas' : 'Protected nature territories',
    'Ostas ceļi' : 'Fairways',
    'Ceļu dziļumi' : 'Depth',
    'Kuģotājiem' : 'Shipping',
    '360° panorāma' :'360° panorama',
    'Piestātnes' : 'Berths',
    'Dzelzceļš ostā' : 'Railway in the port',
    'Infrastruktūra' : 'Infrastructure',
    'Brīvās teritorijas' : 'Free Territories',
  },
  ru: {
    "Teritorijas un servisi": "Территории и услуги",
    "Teritorijas": "Территории",
    "Kravām" : "Для грузов",
    "Pasažieriem" : "Для пассажиров",
    "Visi objekti" : "Показать все",
    'Jahtām' : 'Для яхт',
    'Ostas serviss' : 'Услуги порта',
    'Zaļās zonas' : 'Зеленые зоны',
    'Aizsargājamās teritorijas' : 'Охраняемые природные территории',
    'Ostas ceļi' : 'Судоходные каналы',
    'Ceļu dziļumi' : 'Фарватеры',
    'Kuģotājiem' : 'Для моряков',
    '360° panorāma' :'Панорама 360°',
    'Piestātnes' : 'Причалы',
    'Dzelzceļš ostā' : 'Железная дорога в порту',
    'Infrastruktūra' : 'Инфраструктура',
    'Brīvās teritorijas' : 'Свободные территории',    
  },
};

export default function App(props) {
  return (
    <TranslateProvider root="i18n" lang={props.language} fallbackLang="lv" translations={translations}>
      <Map />
    </TranslateProvider>
  );
}
